module.exports = __webpack_public_path__ + "static/media/dowley_turner_real_estate.149692e8.png";